<template>
<section id="headd">
<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
      <div class="container">
        <a class="navbar-brand js-scroll-trigger" href="/">
          <img src="https://res.cloudinary.com/codeinstd/image/upload/v1602498856/Logo_exphyv.png"
        /></a>
        <button
          class="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
          id = "navbar-collapse"
        >
              <span class="navbar-toggler-icon" style = "width: 30px ; height: 30px;"
></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav text-uppercase ml-auto">
              
            <li class="nav-item">
              <router-link :to="{ name: 'About' }">
              <a class="nav-link js-scroll-trigger nav-detail"  style = "color : #2D2D2D ; font-size: 16px ; font-weight: bold">About</a>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'Services' }">
              <a class="nav-link js-scroll-trigger nav-detail" style = "color : #2D2D2D ; font-size: 16px ; font-weight: bold"
                >Services</a
              >
              </router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger nav-detail" style = "color : #2D2D2D ; font-size: 16px ; font-weight: bold">
              <div class="dropdown">
  <a class="dropbtn nav-detail"  style = "color : #2D2D2D ">Product</a> <i class="fa fa-angle-down"  style = "margin-left: 5px; color : #2D2D2D " ></i>
  <div class="dropdown-content">
    <router-link :to="{ name: 'Pakam' }">
            <p class = "row-bottom-margin nav-detail" id = "navbarResponsive">Pakam Solutions</p> </router-link>
            <router-link :to="{ name: 'Rotes' }">
            <p class = "row-bottom-margin nav-detail ">FIQ Facilities</p>
            </router-link>
            <router-link :to="{ name: 'Report' }">
            <p class = "row-bottom-margin nav-detail ">Report Now</p>
            </router-link>
            <router-link :to="{ name: 'Sanwo' }">
            <p class = "row-bottom-margin nav-detail ">Sanwo 'e</p>
            </router-link>
  </div>

</div>
</a>
              </li>
            <li class="nav-item">
                          <router-link :to="{ name: 'Contact' }">

              <a class="nav-link js-scroll-trigger nav-detail" href="#team" style = "color : #2D2D2D ; font-size: 16px ; font-weight: bold">Contact</a>
                          </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</section>
</template>

<style scoped>

.nav-detail{

   text-transform: none;


}
.nav-detail :hover{

   text-transform: none;
     color: #A31B1F !important;



}

nav-link :hover {
  color: #A31B1F
}

.nav-detail :hover{
  color: #A31B1F !important;
  scale: 0.5;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {background-color: #ddd;
cursor: pointer;}

.dropdown:hover .dropdown-content {display: block;}

.dropdown:hover .dropbtn {background-color:#eee;}

</style>

<script>
import $ from 'jquery'


export default {
  watch: {
    '$route' () {
      $('#navbarResponsive').removeClass('show');
    }
  }
}
</script>